import {Injectable} from "@angular/core";
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {EuropastryBaseHandler} from "@app/core/shared/infrastructure/base.handler/europastry-base.handler";
import {Observable} from "rxjs";
import {catchError, map, switchMap} from "rxjs/operators";
import {PromotionDetail} from "../domain/dtos/promotion-detail";
import {PromotionList} from "../domain/dtos/promotion-list";
import {PromotionRemote} from "../domain/repository/promotion.remote";
import {PromotionDetailMapper} from "./mappers/promotion-detail.mapper";
import {PromotionListMapper} from "./mappers/promotion-list.mapper";

@Injectable({
    providedIn: "root",
})

export class PromotionWebService implements PromotionRemote {

    constructor(
        private baseHandler: EuropastryBaseHandler,
        private credentialsStorage: CredentialsStorage,
        private deliveryPointLocal: DeliveryPointLocal,
        private apiUrls: ApiUrls,
    ) { }

    public getPromotionList(itemsPerPage: number, page: number): Observable<PromotionList> {
        const currentDeliveryPointCode = this.deliveryPointLocal.getDeliveryPointCode();
        const credentials = this.credentialsStorage.getCredentials();

        const parameters = new HandlerBuilder()
            .method(HttpMethod.get)
            .url(this.apiUrls.PROMOTION_LIST + currentDeliveryPointCode + '/' + itemsPerPage + '/' + page)
            .authorization(credentials)
            .build()

        return this.baseHandler.execute(parameters).pipe(
            map(PromotionListMapper.deserialize),
            catchError(BaseHandleErrorMapper.handleError)
        );
    }

    public getPromotionDetail(promotionCode: string): Observable<PromotionDetail> {
        return this.deliveryPointLocal.currentDeliveryPointCode$.pipe(switchMap(deliveryPointCode => {

            const parameters = new HandlerBuilder()
                .method(HttpMethod.get)
                .url(this.apiUrls.PROMOTION_DETAIL + promotionCode + '/' + deliveryPointCode)
                .authorization(this.credentialsStorage.getCredentials())
                .build()

            return this.baseHandler.execute(parameters).pipe(
                map((response) => PromotionDetailMapper.deserialize(response.results)),
                catchError(BaseHandleErrorMapper.handleError)
            );
        }));
    }

}
